import type { GamePageTranslations } from "@casino/server/graphql/getCmsGamePagePhrases";
import translatePhrase from "@casino/ui/Games/translatePhrase";

type Args = {
  isOptedIn: boolean;
  isPending: boolean;
  translations?: GamePageTranslations;
};

const boostButtonLabel = ({ isOptedIn, isPending, translations }: Args) => {
  if (isOptedIn) {
    return translatePhrase(
      translations,
      "game.boost.buttonactive",
      "Boost active",
    );
  }
  if (isPending) {
    return translatePhrase(
      translations,
      "game.boost.buttonpending",
      "Opting in…",
    );
  }
  return translatePhrase(translations, "game.boost.button", "Boost & play");
};

export default boostButtonLabel;
